class Student {
  constructor(data) {
    this.$originalData = Object.assign({}, data);
    const {
      id,
      firstname,
      lastname,
      email,
      fullname,
      school_id,
      organisation_id,
    } = data;
    this.guardians = [];
    this.$id = id;
    this.$firstname = firstname;
    this.$lastname = lastname;
    this.$email = email;
    this.$fullname = fullname;
    this.$school_id = school_id;
    this.$organisation_id = organisation_id;
  }

  /**
   * @returns {number}
   */
  id() {
    return this.$id;
  }

  /**
   * @returns {string}
   */
  email() {
    return this.$email;
  }

  /**
   * @returns {string}
   */
  fullname() {
    if (this.$fullname) {
      return this.$fullname;
    }
    this.fullname = `${this.$firstname} ${this.$lastname}`;
    return this.$fullname;
  }

  /**
   * @returns {string}
   */
  firstname() {
    return this.$firstname;
  }

  /**
   * @returns {string}
   */
  lastname() {
    return this.$lastname;
  }

  /**
   * @returns {Array<Guardian>}
   */
  guardians() {
    return this.$guardians || [];
  }
}

export { Student };

